import React from 'react'
import {useSelector} from 'react-redux'
import {useGetErrorDetailBatchQuery} from '../../../../../redux/api/services/batch'
import {RootState} from '../../../../../redux/store'
import ErrorDetailHeader from './components/ErrorDetailHeader'
import CustomTable from '../../../../../helpers/elements/table/CustomTable'
import {errorDetailColumns} from '../../../../../helpers/elements/table/columns/_columns'

export const ErrorDetailPage = () => {
  const currentBatchDetail = useSelector((state: RootState) => state.batchDetailsSlice)
  const infoState = useSelector((state: RootState) => state.info)
  const {data, isLoading} = useGetErrorDetailBatchQuery({
    info: infoState,
    requestContent: {batchId: currentBatchDetail.batchId},
  })

  return (
    <>
      {currentBatchDetail.batchId && (
        <div className='card'>
          <ErrorDetailHeader totalErrors={data?.responseContent.errors.length.toString()} />
          <div className='card-body'>
            <CustomTable
              batchList={data?.responseContent.errors || []}
              isLoading={isLoading}
              columns={errorDetailColumns}
            />
          </div>
        </div>
      )}
    </>
  )
}
